import { ActionButton } from "@eisox/design-system";
import { ArrowRightIcon } from "@eisox/icons";

import { useFormContext } from "../form.context";

interface SubmitButtonProps {
  label: string;
  icon?: React.ReactNode;
  className?: string;
}

export function SubmitButton({ label, icon, className }: SubmitButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={state => ({ isSubmitting: state.isSubmitting, isDirty: state.isDirty })}>
      {({ isSubmitting, isDirty }) => (
        <ActionButton type="submit" variant="primary" disabled={isSubmitting || !isDirty} className={className}>
          {label} {icon ?? <ArrowRightIcon />}
        </ActionButton>
      )}
    </form.Subscribe>
  );
}

export type { SubmitButtonProps };
